import { Box, alpha, keyframes, styled } from '@mui/material';

const morph2 = keyframes`
  0%, 100% {
    border-radius: 40% 60% 70% 30% / 40% 50% 50% 60%;
    transform: translate(25%, -5%) scale(1.1);
  }
  50% {
    border-radius: 70% 30% 40% 60% / 60% 40% 60% 40%;
    transform: translate(-15%, 25%) scale(0.9);
  }
`;

const morph3 = keyframes`
  0%, 100% {
    border-radius: 50% 50% 35% 65% / 70% 30% 70% 30%;
    transform: translate(-30%, 30%) scale(0.85);
  }
  50% {
    border-radius: 25% 75% 50% 50% / 50% 50% 25% 75%;
    transform: translate(20%, -20%) scale(1.2);
  }
`;

const blobBase = {
  position: 'absolute' as const,
  width: '60%',
  height: '130%',
  filter: 'blur(56px)',
  willChange: 'transform, border-radius',
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
};

export const MorphingBackground = styled(Box)(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
  opacity: 1,
  transition: 'opacity 600ms ease-out',
  '&[data-frozen="true"]': {
    opacity: 0.35,
    '& > *': {
      animationPlayState: 'paused',
    },
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    backgroundColor: alpha(theme.palette.background.paper, 0.55),
  },
}));

export const BlobSecondary = styled(Box)(({ theme }) => ({
  ...blobBase,
  bottom: '-20%',
  left: '-10%',
  width: '120%',
  height: '160%',
  background: theme.palette.common.blue2,
  opacity: theme.palette.mode === 'dark' ? 0.4 : 0.6,
  animation: `${morph2} 14.4s ease-in-out infinite`,
  animationDelay: '-3s',
}));

export const BlobAccent = styled(Box)(({ theme }) => ({
  ...blobBase,
  bottom: '-20%',
  left: '25%',
  width: '50%',
  height: '90%',
  background: theme.palette.accent?.main,
  opacity: theme.palette.mode === 'dark' ? 0.38 : 0.6,
  animation: `${morph3} 17.6s ease-in-out infinite`,
  animationDelay: '-7s',
}));
